// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../shared/action-creators/busy-counter';
import actions from '../../shared/actions-list';
import {getSubClaimTypes} from '../../shared/repositories';

export const readSubClaimTypes = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getSubClaimTypes();

            dispatch({
                data,
                type: actions.UPDATE_SUB_CLAIM_TYPES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/app/action-creators/sub-claim-types.js